import React, {useState} from 'react';
import { useFormik } from 'formik';
import { register } from '../api/register';
import * as Yup from 'yup';
import { ValidationMessage } from '../../Helpers/validation/validationMessage';
import { setLoggedInUser } from '../reducers/loginState';
import { setCurrentPage } from '../../Navigation/currentPage';
import { SCR_COMPETITION } from '../../enums';
import { getLabel } from '../../Language/labels';
import { RequiredFieldMarker } from '../../Competition/components/fields/requiredFieldMarker';
import { recaptchaValidate } from '../api/recaptchaValidate';
import { get } from 'lodash';

export const RegisterForm = ({ countries, nationalities, dispatch }) => {

  //const [apiError, setApiError] = useState([]);
  const [processing, setProcessing] = useState(false);

  const registerSchema = Yup.object().shape({
    forename: Yup.string().required(getLabel('registerFirstNameRequired')),
    surname: Yup.string().required(getLabel('registerLastNameRequired')),
    country_id: Yup.number().required(getLabel('registerCountryRequired')),
    nationality_id: Yup.number().required(getLabel('registerNationalityRequired')),
    email: Yup.string().email(getLabel('emailNotValid')).required(getLabel('emailRequired')),
    email_confirm: Yup.string().oneOf([Yup.ref('email'), null], getLabel('registerEmailsMustMatch')),
    password: Yup.string().min(8, getLabel('registerPasswordMinEight')).required(getLabel('passwordRequired')),
    password_confirm: Yup.string().oneOf([Yup.ref('password'), null], getLabel('registerPasswordsMustMatch')),
    allow_marketing: Yup.number().required(getLabel('requiredField')),
    allow_third_party: Yup.number().required(getLabel('requiredField')),
    terms: Yup.bool().required(getLabel('registerTandCRequired')),
  });

  const formik = useFormik({
    initialValues: {
      // forename: 'test',
      // surname: 'test',
      // country_id: 1215,
      // nationality_id: 1457,
      // email: 'email4@example.com',
      // email_confirm: 'email4@example.com',
      // password: '23456babC@',
      // password_confirm: '23456babC@',
      // allow_marketing: '0',
      // allow_third_party: '0',
      // terms: true,
      forename: '',
      surname: '',
      country_id: '',
      nationality_id: '',
      email: '',
      email_confirm: '',
      password: '',
      password_confirm: '',
      allow_marketing: '',
      allow_third_party: '',
      terms: false,
    },
    validationSchema: registerSchema,
    onSubmit: async function (values, { setFieldError }) {
      setProcessing(true);
      //get the recaptcha token
      const recaptchaResult = await recaptchaValidate();

      // set an error message on a specific field:
      // setFieldError('password', 'Password requires at least one uppercase letter, number and symbol')
      //only interest in email and password in case the email is in use and / or the password is too weak
      const result = await register(values, recaptchaResult).catch(({ response }) => {
        console.log(response);
        const { data: { errors: { email, password } } } = response;
        
        if (email) {
          setFieldError('email', email[0]);
        } 
        
        if(password) {
          // var temp = getLabel('registerPasswordRules');
          // debugger;
          // setApiError([getLabel('registerPasswordRules')]);
          setFieldError('password', getLabel(password[0]));
        }

      });

      if (result) { //request OK - put the profile in state and navigate to the competition category screen
        
        //if status is 200 trigger the facebook pixel / google tag manager events
        if (result.status === 200) {
          if (window.fbq) {
            window.fbq('track', 'CompleteRegistration');
          }

          if (window.dataLayer) {
            window.dataLayer.push({'event': 'complete_registration'});
          }
        }
        //result.data.data.token.data.auth
        const token = get(result, 'data.data.token.data.auth', '');

        if (token.length === 0) {
          alert('Registration failed, auth token not found');
          return;
        }

        dispatch(setLoggedInUser({...result.data.data, token}));

        //registration OK so navigate to the competition tabs view
        dispatch(setCurrentPage(SCR_COMPETITION));
      }
      setProcessing(false);
    }
  })

  return (
    <div className='register-form-container'>
      <div className='register-form-title'>
        <h1 className='text-4xl'>{getLabel('registerTitle')}</h1>
      </div>
      {/* {apiError.length > 0 && <div className='text-xl px-6 border-l border-r border-gray-500'>
        <ul>
          {apiError.map((error, i) => <li key={i}>{error}</li>)}
        </ul>
        </div>} */}
      <form className='form register-form' onSubmit={formik.handleSubmit}>
        <div className='register-form-inner'>
          <label className='form-control' htmlFor="forename">
            <span>{getLabel('registerFirstName')}</span><RequiredFieldMarker />
            <input type="text" id="forename" required
              onChange={formik.handleChange}
              value={formik.values.forename} />
            <ValidationMessage error={formik.errors.forename} touched={formik.touched.forename} />
          </label>

          <label className='form-control' htmlFor="surname">
            <span>{getLabel('registerLastName')}</span><RequiredFieldMarker />
            <input type="text" id="surname" required
              onChange={formik.handleChange}
              value={formik.values.surname} />
            <ValidationMessage error={formik.errors.surname} touched={formik.touched.surname} />
          </label>

          <label className='form-control' htmlFor="country_id">
            <span>{getLabel('registerCountry')}</span><RequiredFieldMarker />
            <select id="country_id" onChange={formik.handleChange} value={formik.values.country_id} required>
              <option value="">{getLabel('registerSelectCountry')}</option>
              {countries.map(obj => <option key={obj.id} value={obj.id}>{obj.name}</option>)}
            </select>
            <ValidationMessage error={formik.errors.country_id} touched={formik.touched.country_id} />
          </label>

          <label className='form-control' htmlFor="nationality_id">
            <span>{getLabel('registerNationality')}</span><RequiredFieldMarker />
            <select id="nationality_id" onChange={formik.handleChange} value={formik.values.nationality_id} required>
              <option value="">{getLabel('registerSelectNationality')}</option>
              {nationalities.map(obj => <option key={obj.id} value={obj.id}>{obj.name}</option>)}
            </select>
            <ValidationMessage error={formik.errors.nationality_id} touched={formik.touched.nationality_id} />
          </label>

          <label className='form-control' htmlFor="email">
            <span>{getLabel('email')}</span><RequiredFieldMarker />
            <input type="email" id="email" required
              onChange={formik.handleChange}
              value={formik.values.email} />
            <ValidationMessage error={formik.errors.email} touched={formik.touched.email} />
          </label>

          <label className='form-control' htmlFor="email_confirm">
            <span>{getLabel('registerConfirmEmail')}</span><RequiredFieldMarker />
            <input type="email" id="email_confirm" required
              onChange={formik.handleChange}
              value={formik.values.email_confirm} />
            <ValidationMessage error={formik.errors.email_confirm} touched={formik.touched.email_confirm} />
          </label>

          <label className='form-control' htmlFor="password">
            <span>{getLabel('password')}. {getLabel('registerPasswordRules')} <span className={`required-field-marker inline-block`}>*</span></span>
            <input type="password" id="password" required
              onChange={formik.handleChange}
              value={formik.values.password} />
              {/* <span className='password-help'>{getLabel('registerPasswordRules')}</span> */}
            <ValidationMessage error={formik.errors.password} touched={formik.touched.password} />
          </label>

          <label className='form-control' htmlFor="password_confirm">
            <span>{getLabel('registerConfirmPassword')}. {getLabel('registerPasswordRules')} <span className={`required-field-marker inline-block`}>*</span></span>
            <input type="password" id="password_confirm" required
              onChange={formik.handleChange}
              value={formik.values.password_confirm} />
              {/* <span className='password-help'>{getLabel('registerPasswordRules')}</span> */}
            <ValidationMessage error={formik.errors.password_confirm} touched={formik.touched.password_confirm} />
          </label>

          <label className='form-control' htmlFor="allow_marketing">
            <span>{getLabel('registerNewsletter')}</span><RequiredFieldMarker />
            <select id="allow_marketing" onChange={formik.handleChange} value={formik.values.allow_marketing} required>
              <option value="">{getLabel('select')}</option>
              <option value="1">{getLabel('yes')}</option>
              <option value="0">{getLabel('no')}</option>
            </select>
            <ValidationMessage error={formik.errors.allow_marketing} touched={formik.touched.allow_marketing} />
          </label>

          <label className='form-control' htmlFor="allow_third_party">
            <span>{getLabel('registerThirdParty')}</span><RequiredFieldMarker />
            <select id="allow_third_party" onChange={formik.handleChange} value={formik.values.allow_third_party} required>
              <option value="">{getLabel('select')}</option>
              <option value="1">{getLabel('yes')}</option>
              <option value="0">{getLabel('no')}</option>
            </select>
            <ValidationMessage error={formik.errors.allow_third_party} touched={formik.touched.allow_third_party} />
          </label>

          <label className='form-control form-checkbox' htmlFor="terms">
            <input id="terms" type="checkbox" onChange={formik.handleChange} required
              value={formik.values.terms} />
            <span htmlFor="terms">{getLabel('registerTandC')}</span><RequiredFieldMarker />
            <ValidationMessage error={formik.errors.terms} touched={formik.touched.terms} />
          </label>

          <div className='form-control register-form-submit'>
            {!processing && <button className='form-submit' type="submit">{getLabel('registerButton')}</button>}
            {processing && <div className='form-submit'>{getLabel('registerButton')}</div>}
          </div>
        </div>
      </form>
    </div>
  )
}